import * as React from 'react';
import { ICON_NAMES } from '../shared/Constants';
import Folder from '@mui/icons-material/Folder';
import FileTypeIcon from './common/FileTypeIcon';
import { splitLastOccurrence } from '../utility/UtilityFunctions';

// Styles

const imgStyles = {
	fontSize: 18,
	color: '#e8b864',
};

const customIconCell = params => {
	let name = '';
	if (params?.row?.revAttPath) {
		const { extension } = splitLastOccurrence(params?.row?.revAttPath);
		if (extension) name = params?.row?.revAttPath;
	}

	if (!name) {
		name = params?.row?.name || params?.row?.SysrdAttPath;
	}

	if (params.row.Icon) {
		switch (params.row.Icon) {
			case ICON_NAMES.FOLDER:
				return <Folder style={imgStyles} />;

			case ICON_NAMES.FILE:
			case ICON_NAMES.FILE_REVERSE:
				return <FileTypeIcon name={name} />;

			default:
				return <Folder style={imgStyles} />;
		}
	} else {
		return <Folder style={imgStyles} />;
	}
};

export default customIconCell;
